/**
 * Footer component
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../ui/Container';

/**
 * Footer component
 */
export const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-darker border-t border-brand-gray-800">
      <Container>
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold text-white mb-4">
              Master <span className="text-brand-gold">Polyglots</span>
            </h3>
            <p className="text-gray-400 text-sm">
              Premium coding bootcamps taught by world-class software engineers.
            </p>
          </div>
          
          {/* Courses */}
          <div>
            <h4 className="text-white font-semibold mb-4">Courses</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/courses" className="text-gray-400 hover:text-white transition-colors text-sm">
                  All Courses
                </Link>
              </li>
              <li>
                <Link to="/courses?level=beginner" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Beginner
                </Link>
              </li>
              <li>
                <Link to="/courses?level=intermediate" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Intermediate
                </Link>
              </li>
              <li>
                <Link to="/courses?level=advanced" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Advanced
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/instructors" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Instructors
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Courses
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-brand-gray-800 py-6">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Master Polyglots. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};
